import React from "react";

const SECTIONS = {
  Privacy: [
    ["Information we collect", "We collect details you provide (name, email, phone) and usage data to improve learning outcomes."],
    ["How we use it", "Used to deliver courses, send updates, and personalise recommendations. Never sold to third parties."],
    ["Your rights", "You can request export or deletion of your data at any time at privacy@alearnindia.com."],
  ],
  Terms: [
    ["Accounts", "You agree to provide accurate info. Accounts are personal and non-transferable."],
    ["Refunds", "7-day money-back guarantee on most courses. See refund policy for details."],
    ["Conduct", "Be kind in forums and live classes. Harassment leads to immediate account removal."],
  ],
};

export default function Legal({ kind }) {
  const data = SECTIONS[kind];
  return (
    <main className="pt-28 pb-24">
      <div className="max-w-3xl mx-auto px-4">
        <div className="ali-chip">{kind}</div>
        <h1 className="mt-4 font-satoshi font-black text-4xl text-[#0A192F]">{kind} Policy</h1>
        <div className="mt-8 space-y-6">
          {data.map(([t, d], i) => (
            <div key={i} className="ali-card p-6" data-testid={`legal-${kind}-${i}`}>
              <h3 className="font-satoshi font-bold text-lg text-[#0A192F]">{t}</h3>
              <p className="mt-2 text-slate-600 font-inter">{d}</p>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
}
